/**
 * Implementation of all monitors page
 * 
 * @author - Harsh Tomar
 */

// Dependencies
import React from 'react';
import AllMonitors from '../../../components/AllMonitors';

const monitors = [
  {
    id: '1',
    name: "Instatweet",
    url: "instatweet.com",
    type: "WEBSITE" as "WEBSITE" | "API",
    regions: ["ca", "us", "sa", "in", "gb", "br", "bh", "id", "au"],
    status: "LIVE" as "LIVE" | "PAUSED" | "ALERTED",
    uptime: 99.23,
    latency: '1230ms'
  },
  {
    id: '2',
    name: "Instatweet API",
    url: "api.instatweet.com",
    type: "API" as "WEBSITE" | "API",
    regions: ["au", "gb", "us", "in"],
    status: "LIVE" as "LIVE" | "PAUSED" | "ALERTED",
    uptime: 99.97,
    latency: '340ms'
  }
]

export default function Monitors() {

  return (
    <div className="bg-white rounded-xl shadow p-5 mb-5 flex-1">
        <h1 className="text-lg mb-3 font-semibold">All Monitors</h1>

        {/* <AllMonitors data={monitors}/> */}
        
      </div>
  )
}